import { Module } from "../Module.js";
import { resolveValue } from "../utils/ui-helpers.js";

export class DataModule extends Module {

    constructor(parent, options = {}) {

        options = Object.assign({
            moduleName: () => this.getDataModel().getEntityName(),
            moduleTitle: () => this.getDataModel().getLabel(),
            dataModel: null,
            dataManager: null,
            data: null,
            userCanReadData: function () { return this.evaluateModelPrivilege('read'); },
            userCanCreateData: function () { return this.evaluateModelPrivilege('create'); },
            userCanUpdateData: function () { return this.evaluateModelPrivilege('update'); },
            userCanDeleteData: function () { return this.evaluateModelPrivilege('delete'); },
            onDataChange: null,
        }, options || {});

        super(parent, options);

        const {
            dataModel = null,
            dataManager = null,
            data = null,
            userCanReadData = true,
            userCanCreateData = true,
            userCanUpdateData = true,
            userCanDeleteData = true,
            onDataChange = null,
        } = options;

        this.dataModel = dataModel;
        this.dataManager = dataManager;
        this.data = data;
        this.userCanReadData = userCanReadData;
        this.userCanCreateData = userCanCreateData;
        this.userCanUpdateData = userCanUpdateData;
        this.userCanDeleteData = userCanDeleteData;
        this.onDataChange = onDataChange;

    }

    // --------------------------------------------------------------------------------------------

    getDataModel() { return resolveValue(this.dataModel, this); };

    getDataManager() {

        const dataManager = resolveValue(this.dataManager, this);
        if (dataManager)
            return dataManager;

        return null;

    };

    hasExternalDataBinding() {

        return typeof this.data == 'function';

    };

    setData(data) {

        if (this.hasExternalDataBinding())
            return data;

        this.data = data;
        return data;

    };

    getData() { return resolveValue(this.data, this); };

    validateData() { return true; };

    evaluateModelPrivilege(privilegeKey) {

        const privilegeExpression = this.getDataModel()?.privileges?.[privilegeKey] ?? null;
        if (privilegeExpression === null || privilegeExpression === undefined)
            return true;

        const authManager = this.getApp()?.authManager ?? this.getDataModel()?.authManager ?? null;
        if (!authManager || typeof authManager.validateUserPrivileges !== 'function')
            throw new Error(`[DataModule] auth manager is required for privilege "${privilegeKey}".`);

        return authManager.validateUserPrivileges(privilegeExpression);

    };

    canUserReadData() { return resolveValue(this.userCanReadData, this); };

    canUserCreateData() { return resolveValue(this.userCanCreateData, this); };

    canUserUpdateData() { return resolveValue(this.userCanUpdateData, this); };

    canUserDeleteData() { return resolveValue(this.userCanDeleteData, this); };

    canUserCreateRecord() { return this.canUserCreateData(); };

    canUserUpdateRecord() { return this.canUserUpdateData(); };

    canUserDeleteRecord() { return this.canUserDeleteData(); };


    // --------------------------------------------------------------------------------------------

    async _prepare(options, activeRoute) {

        // nejprve model (kvuli fields) a pak ostatni

        const dataManager = this.getDataManager();
        const dataModel = this.getDataModel()
            || ((dataManager && typeof dataManager.getModel === 'function') ? dataManager.getModel() : null);

        if (dataModel) {
            const app = this.getApp();
            if (typeof app?.prepareDataModel === 'function')
                await app.prepareDataModel(dataModel);
            else
                await dataModel.prepare();
        }

        return super._prepare(options, activeRoute);

    };

    // --------------------------------------------------------------------------------------------

    _render(r, vm) {

        return r.div([
            '[Data Module]'
        ]);

    };

}
